"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Button = _interopRequireWildcard(require("../../../../../../../ui/Button"));
var _SaveToClaim = require("../../../../../../../modals/SaveToClaim");
var _actions = require("../../../../../../store/actions");
var _styles = _interopRequireDefault(require("./styles"));
var _claim = _interopRequireDefault(require("./img/claim.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SaveBasketToClaimButton = function SaveBasketToClaimButton(_ref) {
  var basketID = _ref.basketID;
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKET_EDIT_FORM'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var onSaveBasketToClaim = (0, _react.useCallback)(function () {
    dispatch((0, _SaveToClaim.showSaveToClaimModal)({
      header: t('FORM_TITLE'),
      onSave: function onSave(_ref2) {
        var claimID = _ref2.claimID,
          clientID = _ref2.clientID,
          callbacks = _ref2.callbacks;
        return dispatch((0, _actions.addBasketToClaim)(basketID, claimID, clientID, callbacks));
      },
      showAddNewClaimAndClientButton: false,
      showAddNewClaimButton: false
    }));
  }, [basketID, dispatch, t]);
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.claimButton,
    icon: _claim.default,
    theme: _Button.THEMES.GRAY,
    onClick: onSaveBasketToClaim
  }, t('SELECT_CLAIM_BUTTON'));
};
SaveBasketToClaimButton.propTypes = {
  basketID: _propTypes.default.number.isRequired
};
var _default = exports.default = (0, _react.memo)(SaveBasketToClaimButton);